import { AppBar, IconButton, Toolbar, Tooltip, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Earth from '@/assets/Earth';
import React from 'react';
import colors from '@/style/colors';

const REACT_APP_REGION = process.env.REACT_APP_REGION || 'hk';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    background: colors.primary.dark,
    boxShadow: 'none',
  },
  title: {
    flexGrow: 1,
    padding: 10,
    color: colors.white,
    fontSize: 20,
    fontWeight: 'bold',
  },
  button: {
    padding: 10,
    color: colors.white,
  },
});

export default function Header(props) {
  const classes = useStyles(props);
  const { t, i18n } = useTranslation();
  const [lang, setLang] = React.useState(() => {
    // 從 localStorage 或 i18n 取得當前語言
    return localStorage.getItem('i18nextLng') || i18n.language || 'zh-HK';
  });

  const changeLanguage = () => {
    let newLang;
    if (REACT_APP_REGION === 'hk') {
      if (lang === 'zh-HK') {
        newLang = 'en-US';
      } else if (lang === 'en-US') {
        newLang = 'zh-TW';
      } else if (lang === 'zh-TW') {
        newLang = 'zh-HK';
      }
    } else {
      if (lang === 'th-TH') {
        newLang = 'zh-HK';
      } else if (lang === 'zh-HK') {
        newLang = 'en-US';
      } else if (lang === 'en-US') {
        newLang = 'zh-TW';
      } else if (lang === 'zh-TW') {
        newLang = 'th-TH';
      }
    }

    if (newLang) {
      setLang(newLang);
      i18n.changeLanguage(newLang);
      localStorage.setItem('i18nextLng', newLang);
    }
  };

  const renderEarthIcon = () => {
    let tooltipTitle;
    if (REACT_APP_REGION === 'hk') {
      tooltipTitle = lang === 'zh-HK' ? 'ENG' : lang === 'en-US' ? '中文(台灣)' : '中文(香港)';
    } else {
      tooltipTitle = lang === 'th-TH' ? '中文(香港)' : lang === 'zh-HK' ? 'ENG' : lang === 'en-US' ? '中文(台灣)' : 'ภาษาไทย';
    }

    return (
      <Tooltip title={tooltipTitle}>
        <IconButton
          className={classes.button}
          aria-label='locale'
          component='span'
          onClick={changeLanguage}
        >
          <Earth />
        </IconButton>
      </Tooltip>
    );
  };

  return (
    <AppBar position='static' className={classes.container}>
      <Toolbar style={{ display: 'flex' }}>
        <span className={classes.title}>{t('app.component.header.title')}</span>
        {renderEarthIcon()}
      </Toolbar>
    </AppBar>
  );
}
